import router from "@/router";
import { API } from "@/services";
import { HELPER_FUNCTIONS } from "@/utils/index";
import { LOGOUT, REFRESH_TOKEN } from "../constants/actions";
import { GET_IS_LOGGED_IN, GET_TOKEN, GET_REFRESH_TOKEN, GET_TOKEN_PAYLOAD } from "../constants/getters";
import { SET_TOKEN, SET_REFRESH_TOKEN } from "../constants/mutations";
import debounce from 'lodash.debounce'
import { routes_names } from "@/router/constants";
export default {
  state: {
    token: '',
    refresh_token: '',
  },
  getters: {
    [GET_TOKEN](state){ return state.token },
    [GET_TOKEN_PAYLOAD](state,getters){ return HELPER_FUNCTIONS.parseJwt(getters[GET_TOKEN]) ?? {} },
    [GET_REFRESH_TOKEN](state){ return state.refresh_token },
    [GET_IS_LOGGED_IN](state,getters){ return !!getters[GET_TOKEN]},
  },
  actions: {
    [REFRESH_TOKEN]: debounce(async function(context){
      try {
        const { data } = await API.endpoints.auth.refreshToken({
          refresh_token: context.getters[GET_REFRESH_TOKEN]
        })
        context.commit(SET_TOKEN,data.access_token)
        context.commit(SET_REFRESH_TOKEN,data.refresh_token)
      } catch (ex) {
        context.dispatch(LOGOUT)
      }
    },3*1000,{
      leading: true,
      trailing: false,
    }),
    async [LOGOUT](context){
      try {
        const token = context.getters[GET_TOKEN]
        await API.endpoints.auth.logout({},{
          'Authorization': `Bearer ${token}`
        })
      } finally {
        context.commit(SET_TOKEN,'')
        context.commit(SET_REFRESH_TOKEN,'')
        const requiresAuth = router.currentRoute.matched.some((record) => record.meta.requiresAuth)
        if(requiresAuth) {
          router.push({
            name: routes_names.login
          })
        }
      }
    },
  },
  mutations: {
    [SET_TOKEN](state,value){
      state.token=value ?? ''
    },
    [SET_REFRESH_TOKEN](state,value){
      state.refresh_token=value ?? ''
    },
  },
};